import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { ISubscriptionsV2User } from '@/Module/Subscription/Model/DataModel';
import SubscriptionService from '@/Module/Subscription/Service/SubscriptionService';

export const getSubscriptionsV2UserAction = createAsyncThunk<IGatewayResponse<ISubscriptionsV2User[]>, string>(
  'subscription/getSubscriptionsV2User',
  async (token, { signal }) => {
    return SubscriptionService.getSubscriptionsV2User(token, signal).then(({ data }) => data);
  },
);
